import { render, staticRenderFns } from "./origin.vue?vue&type=template&id=2bd56850&scoped=true"
import script from "./origin.vue?vue&type=script&lang=js"
export * from "./origin.vue?vue&type=script&lang=js"
import style0 from "./origin.vue?vue&type=style&index=0&id=2bd56850&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bd56850",
  null
  
)

export default component.exports